import React from 'react';

const IconComponent = (props: any) => {
  return (
    <>
      <div className='iconComponent' id={props.id} style={props.divStyles} onClick={props.event} onKeyDown={props.event}>
        <img
          alt={props.alt}
          src={props.icon}
          style={props.imgStyles}
          ></img>
        <span style={props.titleStyles}>{props.title}</span>
      </div>
    </>
  );
};

export default IconComponent;
